// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"B1-z","dimensionLabel":"C1-z","styleChooserControlWrapper":"D1-z","styleChooserControl":"E1-z","disabled":"F1-z","giftCard":"G1-z","styleChooserText":"H1-z"};